import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { JwtHelper } from "angular2-jwt";
import auth0 from "auth0-js";
import { catchError, map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { LocalStorageService } from "./../services/local-storage.service";
import { SettingsConstant } from "./../../shared/constants/settings.constants";
import { TranslateService } from "@ngx-translate/core";
import { GenericHttpService } from "./../../shared/services/generic-http.service";
import { ApiUrlConstant } from "../../shared/constants/api-url.constant";
import { GenericUtils } from './../../shared/utilities/generic-utils';
@Injectable()
export class DlvAuthOService {
  userProfile: any;
  userScope: any;

  auth0Params = SettingsConstant.TELESCOPE_AUTH0_PARAMS;
  auth0 = new auth0.WebAuth(this.auth0Params);

  umsAuth0Params = SettingsConstant.UMS_AUTH0_PARAMS;
  ums_auth0 = new auth0.WebAuth(this.umsAuth0Params);

  loginInterval: any;
  parseHashInterval: any;
  jwtHelper: JwtHelper = new JwtHelper();
  setTimeOutStore: any;
  loginFrameTimeout: any;
  iframeUser: any;

  constructor(
    private toastr: ToastrService,
    private router: Router,
    private translateService: TranslateService,
    private localStorage: LocalStorageService,
    private genericHttp: GenericHttpService,
    private apiUrl: ApiUrlConstant,
    private utils: GenericUtils
  ) { }

  /**
   * Login from AuthO for Telescope
   */
  public login(): void {
    this.loginInterval = setInterval(() => {
      const scope = this.auth0 && this.auth0.baseOptions && this.auth0.baseOptions.scope;
      if (scope) {
        clearInterval(this.loginInterval);
        this.auth0.authorize();
      }
    });
  }

  /**
   * Login from AuthO for ums
   */
  public loginUMS() {
    this.ums_auth0.checkSession({}, (err, result) => {
      if (err) {
        // console.error(err);
      } else {
        this.localStorage.setItem(
          SettingsConstant.LOCALSTORAGE_KEYS.UMS_APP_TOKEN,
          result.accessToken
        );
      }
    });
  }

  /**
   * To check token valid or not valid
   */
  public isAuthenticated(): boolean {
    const expiresAt = JSON.parse(
      localStorage.getItem(SettingsConstant.LOCALSTORAGE_KEYS.EXPIRES_AT)
    );
    return new Date().getTime() < expiresAt;
  }

  public getScopePermission = cb => {
    // const accessToken = this.localStorage.getItem(
    //   SettingsConstant.LOCALSTORAGE_KEYS.TELESCOPE_TOKEN
    // );
    const scopes = this.localStorage.getItem(`${SettingsConstant.LOCALSTORAGE_KEYS.USER_SCOPES}`);

    if (!scopes) {
      throw new Error("No permissions are available");
    }
    // const scopes = this.jwtHelper.decodeToken(accessToken)["scope"];
    const self = this;
    self.userScope = scopes;
    cb(scopes);
  };

  // /**
  //  * Store authinfo to localStorage
  //  * @param authResult {accessToken, idToken,expiresAt}
  //  */
  private setSession(authResult): void {

    const expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    );
    this.localStorage.setItem(
      SettingsConstant.LOCALSTORAGE_KEYS.TELESCOPE_TOKEN,
      authResult.accessToken
    );
    this.localStorage.setItem(
      SettingsConstant.LOCALSTORAGE_KEYS.ID_TOKEN,
      authResult.idToken
    );
    this.localStorage.setItem(
      SettingsConstant.LOCALSTORAGE_KEYS.EXPIRES_AT,
      expiresAt
    );

    this.scheduleRenewal();
    this.loginUMS();
  }

  public removedUnusedScope = (scope, removeScopeArray) => {
    const scopes = scope ? scope.split(" ") : [];
    const data = scopes.filter(item => {
      if (!removeScopeArray.includes(item)) {
        return true;
      }
    });
    return data.length;
  };

  /**
   * Set timeinterval to check token valid or not valid
   */
  public scheduleRenewal() {
    if (!this.isAuthenticated()) return;
    clearTimeout(this.setTimeOutStore);
    const expTime = JSON.parse(
      localStorage.getItem(SettingsConstant.LOCALSTORAGE_KEYS.EXPIRES_AT)
    );
    const time = expTime - new Date().getTime();
    this.setTimeOutStore = setTimeout(() => {
      this.renewTokens();
    }, time - 1000 * 300);
  }

  /**
   * Renew token when session expired
   */
  public renewTokens(isLoader?, cb?) {
    // if (isLoader) {
    //     this.loader.start();
    // }
    this.auth0.checkSession({}, (err, result) => {
      if (err) {
        console.log('renewTokens', err);
        if (this.isLocalStorageValue()) {
          // this.iframeLogin();
          this.logOut();
        } else {
          // this.loader.stop();
          this.router.navigate(["/error"], {
            queryParams: { message: "login_required" }
          });
        }
        return cb ? cb(true) : "";
      } else {
        this.setSession(result);
        return cb ? cb(true) : "";
        // this.loader.stop();
      }
    });
  }

  /**
   * Parse hash url and get store user info like AccessToken, IdToken form hash url
   */
  private parseHash = hash => {
    this.auth0.parseHash({ hash: hash }, (err, authResult) => {
      console.log('parseHash', err);
      if (authResult && authResult.accessToken && authResult.idToken) {
        window.location.hash = "";
        this.setSession(authResult);
        // this.router.navigate([""]);
      } else if (err) {
        console.log('parseHash', err);
        if (err["error"] === "invalid_token") {
          let keywordArr = ["Issued", "iat", "claim", "error", "token", "time"];
          let message = "";
          for (let keyword in keywordArr) {
            if (err["errorDescription"].includes(keyword)) {
              message = "time_error";
            } else {
              message = "";
              break;
            }
          }
          this.router.navigate(["/error"], {
            replaceUrl: true,
            queryParams: { message: message || err["error"] }
          });
        } else if (err["error"] === "access_denied") {
          this.router.navigate(["/error"], {
            replaceUrl: true,
            queryParams: { message: err["error"] }
          });
        } else {
          this.router.navigate(["/error"], {
            replaceUrl: true,
            queryParams: { message: err["error"] }
          });
        }
      } else {
        this.router.navigate(["/error"], {
          replaceUrl: true,
          queryParams: { message: err["error"] }
        });
      }
    });
  };

  /**
   * To store user info like AccessToken, IdToken form hash url
   */
  handleAuthentication(): void {
    const hash = window.location.hash;
    this.parseHashInterval = setInterval(() => {
      const scope =
        this.auth0 && this.auth0.baseOptions && this.auth0.baseOptions.scope;
      if (scope) {
        clearInterval(this.parseHashInterval);
        this.parseHash(hash);
      }
    });
  }

  /**
   * Get Accesstoken from localStorage
   * @returns JwtString or false
   */
  getAccessToken = () => {
    const token = this.localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.TELESCOPE_TOKEN
    );
    if (token) {
      return token;
    } else {
      return false;
    }
  };

  /**
   * Get Idtoken from localStorage
   * @returns JwtString or false
   */
  getIdToken = () => {
    const token = this.localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.ID_TOKEN
    );
    if (token) {
      return token;
    } else {
      return false;
    }
  };

  // /**
  //  * No used currently
  //  */
  public getJWT = () => {
    try {
      if (this.getAccessToken() && this.getIdToken()) {
        const token = {
          AccessToken: this.getAccessToken(),
          IdToken: this.getIdToken()
        };
        return token;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  // /**
  //  * Logout application form Aoth0 and clear LocalStorage
  //  */
  public logOut(): void {
    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.TELESCOPE_TOKEN
    );
    this.localStorage.removeItem(SettingsConstant.LOCALSTORAGE_KEYS.ID_TOKEN);
    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.USER_SCOPES
    );
    this.localStorage.removeItem(SettingsConstant.LOCALSTORAGE_KEYS.USER_UUID);
    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.USER_PERMISSION
    );
    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.USER_DETAILS
    );
    this.localStorage.removeItem(SettingsConstant.LOCALSTORAGE_KEYS.EXPIRES_AT);
    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT
    );

    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.CLIENT_LIST
    );

    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.COOKIE_TOKEN
    );
    this.localStorage.removeItem(
      SettingsConstant.LOCALSTORAGE_KEYS.UMS_APP_TOKEN
    );

    const umsTokenName = `${environment.accessToken}`;
    this.utils.storeCookie(umsTokenName, '', new Date(-1), this.utils.getSubDomainName());
    this.localStorage.removeItem("PAGE_WIDGET_DATA");
    this.router.navigate(['/login'], { replaceUrl: true });
    // this.auth0.logout(
    //   {
    //     returnTo: environment.AUTH_REDIRECT_URI,
    //     clientID: SettingsConstant.TELESCOPE_AUTH0_PARAMS.clientID
    //   },
    //   (err, res) => {
    //     if (res) {
    //       console.log("successfully logout");
    //     } else {
    //       console.error(err);
    //     }
    //   }
    // );
  }

  /**
   * To check token valid or not valid
   */
  public isLocalStorageValue(): boolean {
    const AT = localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.TELESCOPE_TOKEN
    );
    const IDT = localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.ID_TOKEN
    );
    const EXP = localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.EXPIRES_AT
    );
    if (AT && IDT && EXP) {
      return true;
    } else {
      return false;
    }
  }

  public userHasScopes(scopes: Array<string>): boolean {
    const grantedScopes = JSON.parse(
      localStorage.getItem(SettingsConstant.LOCALSTORAGE_KEYS.USER_SCOPES)
    ).split(" ");
    return scopes.every(scope => grantedScopes.includes(scope));
  }

  // /**
  //  * Set logged in userinfo(name)
  //  * @param cb - callback method
  //  */
  public getProfile = (cb): void => {
    const accessToken = this.localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.TELESCOPE_TOKEN
    );
    if (!accessToken) {
      throw new Error("Access Token must exist to fetch profile");
    }
    const idToken = this.localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.ID_TOKEN
    );
    const tokenInfo = {
      id: idToken ? this.jwtHelper.decodeToken(idToken) : {},
      access: accessToken ? this.jwtHelper.decodeToken(accessToken) : {}
    };
    const userName = this.getUserName(
      tokenInfo["access"]["http://delhivery.com/username"]
    );
    const emailInfo = tokenInfo["id"]["name"]
      ? tokenInfo["id"]["name"]
      : userName || "Guest";

    const userInfo = tokenInfo['id'];

    this.localStorage.setItem(
      `${SettingsConstant.LOCALSTORAGE_KEYS.USER_DETAILS}`,
      userInfo
    );

    let uuid = tokenInfo['id']['http://delhivery.com/ums_uuid'] || (tokenInfo['id']['sub'].split('|')[0] === 'auth0' ? tokenInfo['id']['sub'].split('|')[1] : '');

    if (uuid) {
      this.localStorage.setItem(
        `${SettingsConstant.LOCALSTORAGE_KEYS.USER_UUID}`,
        uuid
      );
    } else {
      this.router.navigate(['/forbidden'], { queryParams: { message: 'ERROR: 404UUID, User UUID not found, please contact administrator or try after sometime.' } });
    }

    this.getUserInfo().then(() => cb(userInfo));
  };

  async getUserInfo() {
    let userDetail: any = [];
    if (!this.localStorage.getItem(`${SettingsConstant.LOCALSTORAGE_KEYS.USER_UUID}`)) {
      userDetail = await this.getUserInfoFromUms();
    }
    if (userDetail && userDetail["uuid"]) {
      this.localStorage.setItem(
        `${SettingsConstant.LOCALSTORAGE_KEYS.USER_UUID}`,
        userDetail["uuid"]
      );
      this.localStorage.setItem(
        `${SettingsConstant.LOCALSTORAGE_KEYS.USER_DETAILS}`,
        userDetail
      );
    }

    try {
      let userClient = await this.getUserClientMapping();
    
      if (userClient["data"] && userClient["data"].length) {
        this.localStorage.setItem(`${SettingsConstant.LOCALSTORAGE_KEYS.CLIENT_LIST}`,
          JSON.stringify(userClient["data"]));
        if (userClient["data"].length > 1) {
          /**if there is only one client associated with the logged in user then we will store it on localstorage
                otherwise we will redirect it to select client page
          **/
          const preSelectedClient = this.localStorage.getItem(
            `${SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT}`);
          if (!preSelectedClient) {
            this.localStorage.setItem(
              `${SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT}`,
              userClient["data"][0]["client_uuid"]
            );
          }
        } else {
          this.localStorage.setItem(
            `${SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT}`,
            userClient["data"][0]["client_uuid"]
          );
        }
      } else {
        this.router.navigate(['/forbidden'], { queryParams: { message: 'ERROR: 404CLIENT, You dont have any client associated with your account. please contact administrator for adding client in your account.' } });
        //this.logOut();
        //this.router.navigate(["/login"]);
      }
    } catch (e) {
      console.log(e);
    }
  }

  getUserInfoFromUms() {
    const option = {
      method: "GET",
      // url: `${environment.UMS_USER_DETAIL}`
      url: `${environment.gateWayHost}${this.apiUrl.GET_USER_PROFILE}`
    };
    return this.genericHttp.httpRequest(option).toPromise();
  }

  getUserClientMapping() {
    const option = {
      method: "GET",
      url: `${environment.gateWayHost}${this.apiUrl.GET_USER_CLIENTS}`
    };
    return this.genericHttp.httpRequest(option)
      .pipe(
        catchError((err) => {
          let msg = 'ERROR: 403CLIENT, You don\'t have sufficient permissions, please contact administrator.';
          if (err.status === 403) {
            this.router.navigate(['/forbidden'], { queryParams: { message: msg } });
          }
          return Promise.reject();
        }),
        map(this.genericHttp.responseData)
      ).toPromise();
  }

  // /**
  //  * Get Username
  //  * @return any {String, number}
  //  */
  private getUserName = userData => {
    let userName: any = "";
    try {
      const mobNo = Number(userData);
      if (mobNo) {
        userName = mobNo;
      } else {
        userName = userData ? userData.split("@")[0] : "";
      }
    } catch (error) {
      userName = userData ? userData.split("@")[0] : "";
    }

    return userName;
  };

  setMessage = msg => {
    switch (msg) {
      case "access_denied":
        this.toastr.error(
          "Access Denied!!",
          `You don't have access to login this Application.`
        );
        break;
      case "required_login":
        this.toastr.error("Error", `You session is expired!!, Please login.`);
        break;
      case "login_required":
        this.toastr.error(
          "Login Required!!",
          `You session is expired, Please login.`
        );
        break;
      case "something":
        this.toastr.error("Oops!!", `Internal Server Error.`);
        break;
      default:
        this.toastr.error(msg, "Somthing went wrong!");
    }
  };

  convertToken() {
    const config = {
      method: "POST",
      url: `${environment.UMS_TOKEN_CONVERT_API}`
    };
    return this.genericHttp
      .httpRequest(config)
      .pipe(catchError(this.genericHttp.handleError));
  }

  getConvertedToken() {
    this.convertToken().subscribe(
      res => {
        // this.storeCookie('ums_token', res['jwt'])
        this.localStorage.setItem(
          SettingsConstant.LOCALSTORAGE_KEYS.COOKIE_TOKEN,
          res["jwt"]
        );
      },
      error => {
        console.log(error);
      }
    );
  }

  storeCookie(name, value, domain, expiry) {
    let expires = "";
    let cookieValue = "";
    if (expiry) {
      expires = "expires=" + expiry;
    } else {
      const d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
      expires = "expires=" + d.toUTCString();
    }
    if (typeof value === "object") {
      cookieValue = JSON.stringify(value);
    } else {
      cookieValue = value;
    }
    // const cookie = (name + '=' + cookieValue + ';path=' + ';domain=' + domain + ';' + expires);
    document.cookie = name + "=" + cookieValue;
  }
}
